module.exports = __webpack_public_path__ + "assets/img/question.0becce59.png";